import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a8a71ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FullPagePDF" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = {
  key: 0,
  class: "desc-error",
  style: {"height":"calc(100vh - (2 * var(--default-body-margin)))"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc-header" }, "NOTE:"),
  /*#__PURE__*/_createElementVNode("div", null, " File not found in our database. Please try again later or search for a different file. ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "center-dropdown-table-container"
}
const _hoisted_11 = { class: "center-dropdown-table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "table-container"
}
const _hoisted_16 = { class: "pdf-viewer" }
const _hoisted_17 = { class: "embedded-pdf" }
const _hoisted_18 = ["src"]

import { ref, Ref, onMounted, provide, inject, computed } from "vue";
import { useRoute } from "vue-router";
// Services
import { IAPILogger } from "@/interfaces/IAPILogger";
import { GetPdfUrl } from "@/services/helpers/Helper";
// Misc
import log from "loglevel";
import ErrorInfo from "@/components/ErrorInfo.vue";
import { AxiosError } from "axios";
import IDownloadJournaledInvoiceBody from "@/interfaces/IDownloadJournaledInvoiceBody";
import { JournaledInvoicesServices } from "@/services/helpers/JournaledInvoicesHelper";

const fileName = "Journaling.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FullPagePDF',
  setup(__props) {

const page: Ref<number> = ref(1);
provide("page", page);

log.debug("Journaling Report PDF");
const Logger: IAPILogger = inject("Logger")!;

const JIServices: JournaledInvoicesServices = new JournaledInvoicesServices();

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
    log.trace("onMounted() FullPagePDF");
    document.title = fileID + ' - UV';

    const name = onMounted.name;
    const Class = fileName + "/" + name;

    if (method.toUpperCase() === "GET") {
        const urlParams = endpointURL + "/" + fileID + "?type=" + fileType;
        var Message = `Getting PDF file using 'GET' method: ${urlParams}`;
        log.debug(`name()\n${Message}`);

        isLoading.value = true;
        await GetPdfUrl(urlParams, fileID)
            .then((url: string) => {
                pdfUrl.value = url;
                let a: HTMLAnchorElement = document.createElement("a");
                a.href = url;
                a.download = fileID;
                a.textContent = `View pdf ${fileType}_${fileID}`;
                document.querySelector("pdf-viewer")?.append(a);

                Logger.LogInformation(Message, Class);
            })
            .catch((error: any) => {
                isLoading.value = false;

                if (error instanceof AxiosError) {
                    showPdfError.value = true;
                    infoError.value = error;
                    showDowloadButton.value = false;
                }

                Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message}`;
                log.error(Message);
                Logger.LogError(Message, Class);
            });
    }
    else if (method.toUpperCase() === "POST") {
        const urlParams = endpointURL;
        const body: IDownloadJournaledInvoiceBody = {
            InvoiceIds: [fileID],
            ZipFile: false,
            JournalingType: fileType,
            DocumentType: documentType
        }
        var Message = `Getting PDF file using 'POST' method, body: ${JSON.stringify(body)}`;
        log.debug(`name()\n${Message}`);

        isLoading.value = true;
        await JIServices.GetInvoiceBillJournalPdfFileUrl(urlParams,body)
            .then((url: string) => {
                pdfUrl.value = url;

                let a = document.createElement("a");
                a.href = url;
                a.download = fileID;
                a.textContent = `View pdf ${fileType}_${fileID}`;
                document.querySelector("pdf-viewer")?.append(a);

                Logger.LogInformation(Message, Class);
            })
            .catch((error: any) => {
                isLoading.value = false;

                if (error instanceof AxiosError) {
                    if (error.response?.status === 400) {
                        showBadRequest.value = true;
                        showDowloadButton.value = false;
                    }
                    else {
                        showPdfError.value = true;
                        infoError.value = error;
                        showDowloadButton.value = false;
                    }
                }

                Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message}`;
                log.error(Message);
                Logger.LogError(Message, Class);
            });
    }
    else { throw new Error("REST API method not supported or recognised"); }

    isLoading.value = false;
});

// ERRORS
const ShowPdfErrorInfo = ErrorInfo;
const showPdfError: Ref<boolean> = ref(false);
const showPdfErrorChanger: Ref<boolean> = ref(true);
const infoError: Ref<AxiosError | undefined> = ref(undefined);
const showDowloadButton: Ref<boolean> = ref(true);
const showBadRequest: Ref<boolean> = ref(false);

// TABLE
const isLoading = ref(false);

// ROUTE
const route = useRoute();
const fileID = route.params.id as string; 
const documentType = route.params.documentType as string;
const fileType = route.query.type as string;
const endpointURL = route.query.endpoint as string;
const method = route.query.method as string;

const displayDocumentType = computed<boolean>(()=>{
    return (documentType=="" || documentType == undefined)? false : true
})

// PDF
const pdfUrl: Ref<string | undefined> = ref(undefined);

function DownloadPdf() {
    log.trace(`DownloadPdf()\nFile Type: ${fileType}, File ID: ${fileID}`);

    const downloadLink = document.createElement("a");
    downloadLink.href = pdfUrl.value!;
    downloadLink.download = fileID ;
    // downloadLink.target = "_blank";
    downloadLink.setAttribute("target", "_blank");

    // Trigger download link
    downloadLink.click();

    // Clean up
    URL.revokeObjectURL(downloadLink.href);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ShowPdfErrorInfo), {
              showError: showPdfError.value,
              closeError: true,
              errorDescription: "(Downloading PDF)",
              error: infoError.value,
              change: showPdfErrorChanger.value
            }, null, 8, ["showError", "error", "change"]),
            (showBadRequest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
            (showDowloadButton.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_unref(fileID)) + " ", 1),
                          (displayDocumentType.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " - " + _toDisplayString(_unref(documentType)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (DownloadPdf())),
                              title: `Download ${_unref(fileID)}`,
                              class: "table-button"
                            }, " Download File ", 8, _hoisted_13)
                          ])
                        ]),
                        _hoisted_14
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (pdfUrl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("embed", {
                      src: pdfUrl.value,
                      type: "application/pdf"
                    }, null, 8, _hoisted_18)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})